const config = {
  mainTitle: 'Calendar Date Ranges',
  subHeading: 'A page to view, edit and add to date ranges for the calendar.',
  titleIcon: 'MdCalendar'
}

export default config
